import React from "react";
import { Context, Day } from "../types";

interface ContextButtonProps {
  context: Context;
  days: Day[];
  selectedDay: string;
  pressStartTime: number | null;
  pressScale: number;
  pressedItemId: number | null;
  onPressStart: (context: Context, event: React.MouseEvent | React.TouchEvent) => void;
  onPressMove: (event: React.MouseEvent | React.TouchEvent) => void;
  onPressEnd: (context: Context) => void;
  onPressCancel: () => void;
  onClick: (context: Context) => void;
}

export const ContextButton: React.FC<ContextButtonProps> = ({
  context,
  days,
  selectedDay,
  pressStartTime,
  pressScale,
  pressedItemId,
  onPressStart,
  onPressMove,
  onPressEnd,
  onPressCancel,
  onClick,
}) => {
  const isActive = days.find(day => day.date === selectedDay)?.contexts?.includes(context.id);

  return (
    <button
      onMouseDown={(e) => onPressStart(context, e)}
      onMouseMove={onPressMove}
      onMouseUp={() => onPressEnd(context)}
      onMouseLeave={onPressCancel}
      onTouchStart={(e) => onPressStart(context, e)}
      onTouchMove={onPressMove}
      onTouchEnd={() => onPressEnd(context)}
      onTouchCancel={onPressCancel}
      onClick={(e) => {
        if (pressStartTime) {
          e.preventDefault();
          return;
        }
        onClick(context);
      }}
      style={{
        backgroundColor: isActive ? context.color : "transparent",
        border: `1px solid ${context.color}`,
        borderRadius: "16px",
        padding: "8px 12px",
        cursor: "pointer",
        color: isActive ? "#fff" : context.color,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        transition: "all 0.2s ease",
        opacity: isActive ? 1 : 0.7,
        transform: pressedItemId === context.id ? `scale(${pressScale})` : 'scale(1)',
        transformOrigin: "center",
        WebkitTapHighlightColor: "transparent",
        touchAction: "manipulation",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none"
      }}
    >
      <div style={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: isActive ? "#fff" : context.color,
        flexShrink: 0
      }} />
      <span>{context.name}</span>
    </button>
  );
};